import Vue from 'vue'
import Router from 'vue-router'


import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; //引用 element-ui 样式
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);


import login from '@/views/login'

import background from '@/views/background'
// 系统管理
import lessonManagement from '@/views/system/lessonManagement'
import userManagement from '@/views/system/userManagement'
import partManagement from '@/views/system/partManagement'
import knowledgeManagement from '@/views/system/knowledgeManagement'
import tagManagement from '@/views/system/tagManagement'

// 题库管理
import classManagement from '@/views/problem/classManagement'
import questionManagement from '@/views/problem/questionManagement'
import questionCheck from '@/views/problem/questionCheck'
import questionList from '@/views/problem/questionList'
import questionApproval from '@/views/problem/questionApproval'
import myQuestion from '@/views/problem/myQuestion'
import expert from '@/views/problem/expert'

// 教学管理
import progress from '@/views/teach/progress'
import effort from '@/views/teach/effort'
import download from '@/views/teach/download'
import batch from '@/views/teach/batch'
import student from '@/views/teach/student'

// 报告管理
import reportLibrary from '@/views/report/reportLibrary'
import treasuryApproval from '@/views/report/treasuryApproval'
import myApplication from '@/views/report/myApplication'
import MyApproval from '@/views/report/MyApproval'

Vue.use(Router)


export default new Router({
    mode: 'history',
    routes: [
    {
      path: "",
      redirect: "/login"
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },

      {
      path: '/background',
      name: 'background',
      component: background
    },

       {
      path: '/bbb',
      name: 'bbb',
      component: background
    },
    // 系统管理
    {
      path: '/lessonManagement',
      name: 'lessonManagement',
      component: lessonManagement
    },
    {
      path: '/userManagement',
      name: 'userManagement',
      component: userManagement
    },
    {
      path: '/partManagement',
      name: 'partManagement',
      component: partManagement
    },
    {
      path: '/knowledgeManagement',
      name: 'knowledgeManagement',
      component: knowledgeManagement
    },

    {
      path: '/tagManagement',
      name: 'tagManagement',
      component: tagManagement
    },
    // 题库管理
    {
      path: '/classManagement',
      name: 'classManagement',
      component: classManagement
    },
    {
      path: '/questionManagement',
      name: 'questionManagement',
      component: questionManagement
    },
    {
      path: '/questionCheck',
      name: 'questionCheck',
      component: questionCheck
    },
    {
      path: '/questionList',
      name: 'questionList',
      component: questionList
    },
    {
      path: '/questionApproval',
      name: 'questionApproval',
      component: questionApproval
    },
    {
      path: '/myQuestion',
      name: 'myQuestion',
      component: myQuestion
    },
    {
      path: '/expert',
      name: 'expert',
      component: expert
    },
    // 教学管理
    {
      path: '/progress',
      name: 'progress',
      component: progress
    },
    {
      path: '/effort',
      name: 'effort',
      component: effort
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/batch',
      name: 'batch',
      component: batch
    },
    {
      path: '/student',
      name: 'student',
      component: student
    },
    // 报告管理
    {
      path: '/reportLibrary',
      name: 'reportLibrary',
      component: reportLibrary
    },
    {
      path: '/treasuryApproval',
      name: 'treasuryApproval',
      component: treasuryApproval
    },
    {
      path: '/myApplication',
      name: 'myApplication',
      component: myApplication
    },
    {
      path: '/MyApproval',
      name: 'MyApproval',
      component: MyApproval
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js